import React, { useContext, useEffect, useState } from "react";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import AuthContext from "context/AuthContext";
import { isEmpty } from "lodash";
import helper from "../../utils/helpers";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { apiDelete } from "utils/apiFetch";
import apiPath from "utils/apiPath";

const AddressTable = ({
  address,
  setShowModal,
  paginationObj,
  sort,
  setSearch,
  setSort,
  manager,
  pathname,
  allAddress,
}) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const permission = user?.permission?.find(
    (e) => e.manager === "location_manager",
  );

  const [path, setPath] = useState();

  const changePath = (item) => {
    if (pathname === "/city") {
      navigate("/city/community", { state: { id: item?._id } });
      setSearch("");
    } else if (pathname === "/city/community") {
      navigate("/city/subCommunity", { state: { id: item?._id } });
      setSearch("");
    }
  };

  useEffect(() => {
    if (pathname === "/city") {
      setPath("Communities");
    } else if (pathname === "/city/community") {
      setPath("Sub Communities");
    } else if (pathname === "/city/subCommunity") {
      setPath("Cities");
    }
  }, [pathname]);

  const handelDelete = async (item) => {
    try {
      const path = `${
        pathname === "/city/community"
          ? apiPath.locationCommunities
          : apiPath.locationSubCommunities
      }/${item?._id}`;

      const result = await apiDelete(path);
      if (result?.status === 200) {
        allAddress();
        changePath(item);
      }
    } catch (error) {
      console.log("error in get all FAQs list==>>>>", error.message);
    }
  };

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg ">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                #
              </th>

              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (sort.sortKey === "title" && sort.sortType === "asc") {
                    setSort({
                      sortKey: "title",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "title",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex">
                  <span>{t("O_NAME")} </span>
                  <span>
                    {sort.sortKey === "city" && sort.sortType === "asc" && (
                      <BsArrowUpShort className="w-4 h-4" />
                    )}
                    {sort.sortKey === "city" && sort.sortType === "desc" && (
                      <BsArrowUpShort className="w-4 h-4 rotate-180" />
                    )}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 cursor-pointer">
                <div className="flex">
                  <span> {t("O_NAME") + t("O_ARABIC")} </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 cursor-pointer">
                <div className="flex">
                  <span>
                    {t("O_LATITUDE")}, {t("O_LONGITUDE")}
                  </span>
                </div>
              </th>

              {(manager?.add || user?.role === "admin") && (
                <>
                  <th scope="col" className="py-3 px-6 text-center">
                    {t("O_ACTION")}
                  </th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {address &&
              address?.map((item, i) => (
                <tr
                  key={i}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <th
                    scope="row"
                    className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                  >
                    {i + 1 + 10 * (paginationObj?.page - 1)}
                  </th>

                  <td className="py-2 px-2 border-r ">
                    <p
                      onClick={() => changePath(item)}
                      className={`${
                        pathname !== "/city/subCommunity"
                          ? "cursor-pointer"
                          : ""
                      } text-gray-600 hover:text-gray-700`}
                    >
                      {item?.name}
                    </p>
                  </td>
                  <td className="py-2 px-2 border-r ">
                    <p>{item?.nameAr}</p>
                  </td>
                  <td className="py-2 px-2 border-r ">
                    <a href={helper.generateMapURL(item)} target="_blank">
                      {Array.from(item?.location?.coordinates)
                        .reverse()
                        .join(", ")}
                    </a>
                  </td>

                  {(manager?.add || user?.role === "admin") && (
                    <td className="py-4 px-6 border-l flex justify-center">
                      <button
                        title={t("O_UPDATE")}
                        type="button"
                        onClick={() => setShowModal(item)}
                      >
                        <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                      </button>
                      {pathname !== "/city/subCommunity" && (
                        <span
                          className="text-md pl-4 cursor-pointer text-DarkBlue"
                          onClick={() => changePath(item)}
                        >
                          {" "}
                          View {path}{" "}
                        </span>
                      )}

                      {pathname !== "/city" &&
                        (permission?.delete || user?.role === "admin") && (
                          <button
                            title={t("O_DELETE")}
                            className="pl-4 cursor-pointer"
                            onClick={(e) =>
                              helper.alertFunction(
                                `Are you sure want to delete ${
                                  pathname === "/city/community"
                                    ? "community"
                                    : "sub community"
                                }?`,
                                item,
                                handelDelete,
                                true,
                              )
                            }
                          >
                            <AiFillDelete className="w-5 h-5 text-slate-600" />
                          </button>
                        )}
                    </td>
                  )}
                </tr>
              ))}
            {isEmpty(address) && (
              <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6" colSpan={12}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AddressTable;
